import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useContext, useMemo } from 'react';
import { MapContext } from '../util/createView';

const ArcViewContext = createContext(void 0);
const ArcViewProvider = ({ children }) => {
  const [views, setViews] = useState({});
  const onViewMount = useCallback((view, id) => {
    setViews((currViews) => {
      if (id === "current") {
        throw new Error("'current' cannot be used as map id");
      }
      if (currViews[id]) {
        throw new Error(`Multiple maps with the same id: ${id}`);
      }
      return { ...currViews, [id]: view };
    });
  }, []);
  const onViewUnmount = useCallback((id) => {
    setViews((currViews) => {
      if (currViews[id]) {
        const nextViews = { ...currViews };
        delete nextViews[id];
        return nextViews;
      }
      return currViews;
    });
  }, []);
  return /* @__PURE__ */ jsx(
    ArcViewContext.Provider,
    {
      value: {
        views,
        onViewMount,
        onViewUnmount
      },
      children
    }
  );
};
function useView() {
  const views = useContext(ArcViewContext)?.views;
  const currentView = useContext(MapContext);
  if (!views && !currentView) {
    throw new Error("useView must be used within a valid Provider");
  }
  const mapsWithCurrent = useMemo(
    () => ({ ...views, current: currentView }),
    [views, currentView]
  );
  return mapsWithCurrent;
}

export { ArcViewContext, ArcViewProvider, useView };
